module.exports = __webpack_public_path__ + "static/1.2_the_tools_of_history-c5a8056f6193be2ecf0984914bfb921c.pdf";